export default `
    <div class="styles__CategoryList">
          <div class="column featured">
             <div class="group featured">
                <span>
                   <h2 class="title">Featured</h2>
                </span>
                <ul>
                   <li>
                      <a href="/c/20001/men?cm_sp=topnav_m_featured_viewall">
                         <div class="item">
                            <div class="item-label">View All</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001/men?facets=new%3AFSM_NewProduct%3Dnew&amp;cm_sp=topnav_m_featured_newarrivals">
                         <div class="item">
                            <div class="item-label">New Arrivals</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/lookbooks/us-landing-page?cm_sp=topnav_m_featured_wih#catalog/whyihike/page/1">
                         <div class="item">
                            <div class="item-label">Why I Hike</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/lookbooks/us-landing-page?cm_sp=topnav_m_featured_adventuretravel#catalog/adventure-travel/page/1">
                         <div class="item">
                            <div class="item-label">Adventure Travel</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/lookbooks/us-landing-page?cm_sp=topnav_m_featured_rainwear#catalog/rain_19/page/1">
                         <div class="item">
                            <div class="item-label">Rainwear</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/fsm_s_cat20001/men?cm_sp=topnav_m_featured_springsale">
                         <div class="item">
                            <div class="item-label">Spring Sale</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001/men?tab=c&amp;cm_sp=topnav_m_featured_clearance">
                         <div class="item">
                            <div class="item-label">Clearance</div>
                         </div>
                      </a>
                   </li>
                   <li>
                        <a href="/view/big-and-tall/" role="link" title="Big &amp; Tall Clothing for Men">
                           <div class="item">
                              <div class="item-label">Big &amp; Tall Sizes</div>
                           </div>
                        </a>
                     </li>
                </ul>
             </div>
             <div class="group featured">
                <span>
                   <h2 class="title">Activity</h2>
                </span>
                <ul>

                        <li>
                              <a href="/view/men/pajamas/" title="Men's Sleepwear & Pajamas">
                                 <div class="item">
                                    <div class="item-label">Sleepwear</div>
                                 </div>
                              </a>
                           </li>
                           <li>
                                 <a href="/view/men/swimsuits/" title="Men's Swimwear">
                                    <div class="item">
                                       <div class="item-label">Swimwear</div>
                                    </div>
                                 </a>
                              </li>
                              <li>
                                    <a href="/view/workout/" title="Men's Workout">
                                       <div class="item">
                                          <div class="item-label">Workout</div>
                                       </div>
                                    </a>
                                 </li>
                   <li>
                      <a href="/s/mens-hiking-collection?keyword=men%27s+hiking+collection&amp;cm_sp=topnav_m_activities_hiking">
                         <div class="item">
                            <div class="item-label">Hiking</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/s/mens-travel-collection?keyword=men%27s+travel+collection&amp;cm_sp=topnav_m_activities_travel">
                         <div class="item">
                            <div class="item-label">Travel</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/s/mens-fishing-and-field-collection?keyword=men%27s+fishing+and+field+collection&amp;cm_sp=topnav_m_activities_fishingfield">
                         <div class="item">
                            <div class="item-label">Fishing &amp; Field</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/s/mens-training-collection?keyword=men%27s+training+collection&amp;cm_sp=topnav_m_activities_training">
                         <div class="item">
                            <div class="item-label">Training</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/s/mens-mountain-sports-collection?keyword=men%27s+mountain+sports+collection&amp;cm_sp=topnav_m_activities_mountainsports">
                         <div class="item">
                            <div class="item-label">Mountain Sports</div>
                         </div>
                      </a>
                   </li>
                </ul>
             </div>
          </div>
          <div class="column">
             <div class="group">
               <a href="/view/men/jackets/" title="Men's Jackets">
                   <h2 class="title">Jackets</h2>
                </a>
                <ul>
                   <li>
                   <a href="/view/men/jackets/parkas/" title="Men's Parkas">
                         <div class="item">
                            <div class="item-label">Parkas</div>
                         </div>
                      </a>
                   </li>
                   <li>
                   <a href="/view/men/blazers/" title="Men's Blazers">
                      <div class="item">
                         <div class="item-label">Blazers</div>
                      </div>
                   </a>
                </li>
                   <li>
                      <a href="/c/20001-20015-580034/mens-casual?cm_sp=topnav_m_jackets-vests_casual">
                         <div class="item">
                            <div class="item-label">Casual</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20015-580033/mens-insulated?cm_sp=topnav_m_jackets-vests_insulated">
                         <div class="item">
                            <div class="item-label">Insulated</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20015-460006/mens-soft-shells?cm_sp=topnav_m_jackets-vests_softshells">
                         <div class="item">
                            <div class="item-label">Soft Shells</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20015-460005/mens-rainwear?cm_sp=topnav_m_jackets-vests_rainwear">
                         <div class="item">
                            <div class="item-label">Rainwear</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20015-580035/mens-3-in-1?cm_sp=topnav_m_jackets-vests_3-in-1">
                         <div class="item">
                            <div class="item-label">3-in-1</div>
                         </div>
                      </a>
                   </li>
                   <li>
                        <a href="/view/men/vests/" title="Men's Vests">
                         <div class="item">
                            <div class="item-label">Vests</div>
                         </div>
                      </a>
                   </li>
                </ul>
             </div>
             <div class="group">
                <a href="/c/20001-20021/mens-bottoms?cm_sp=topnav_m_bottoms">
                   <h2 class="title">Bottoms</h2>
                </a>
                <ul>
                   <li>
                   <a href="/view/men/pants/" title="Men's Pants">
                         <div class="item">
                            <div class="item-label">Pants</div>
                         </div>
                      </a>
                   </li>
                   <li>
                        <a href="/view/men/pants/features-wrinkle-free/" title="Men's Wrinkle-Free Pants">
                              <div class="item">
                                 <div class="item-label">Wrinkle-Free Pants</div>
                              </div>
                           </a>
                        </li>
                   <li>
                     <a href="/view/men/jeans/" title="Men's Jeans">
                         <div class="item">
                            <div class="item-label">Jeans</div>
                         </div>
                      </a>
                   </li>
                   <li>
                        <a href="/view/men/shorts/" title="Men's Shorts">
                         <div class="item">
                            <div class="item-label">Shorts</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20021-580041/mens-baselayers?cm_sp=topnav_m_bottoms_baselayers">
                         <div class="item">
                            <div class="item-label">Baselayers</div>
                         </div>
                      </a>
                   </li>
                </ul>
             </div>
             <div class="group">
                <a href="/c/20001-20052/mens-tops?cm_sp=topnav_m_tops">
                   <h2 class="title">Tops</h2>
                </a>
                <ul>
                   <li>
                   <a href="/view/men/shirts/" title="Men's Shirts">
                         <div class="item">
                            <div class="item-label">Shirts</div>
                         </div>
                      </a>
                   </li>
                   <li>
                        <a href="/view/men/shirts/features-wrinkle-free/" title="Men's Wrinkle-Free Shirts">
                              <div class="item">
                                 <div class="item-label">Wrinkle-Free Shirts</div>
                              </div>
                           </a>
                        </li>
                   <li>
                      <a href="/c/20001-20052-560001/mens-shirt-jackets?cm_sp=topnav_m_tops_shirt-jackets">
                         <div class="item">
                            <div class="item-label">Shirt Jackets</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20052-20059/mens-t-shirts?cm_sp=topnav_m_tops_t-shirts">
                         <div class="item">
                            <div class="item-label">T-Shirts</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20052-540001/mens-polos?cm_sp=topnav_m_tops_polos">
                         <div class="item">
                            <div class="item-label">Polos</div>
                         </div>
                      </a>
                   </li>
                   <li>
                        <a href="/view/men/sweaters-and-sweatshirts/" title="Men's Sweaters & Sweatshirts">
                         <div class="item">
                            <div class="item-label">Sweaters &amp; Sweatshirts</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20052-580042/mens-baselayers?cm_sp=topnav_m_tops_baselayers">
                         <div class="item">
                            <div class="item-label">Baselayers</div>
                         </div>
                      </a>
                   </li>
                </ul>
             </div>
             <div class="group">
                <a href="/c/20001-140004/mens-fleece?cm_sp=topnav_m_fleece">
                   <h2 class="title">Fleece</h2>
                </a>
                <ul>
                   <li>
                      <a href="/c/20001-140004-20019/mens-technical?cm_sp=topnav_m_fleece_technical">
                         <div class="item">
                            <div class="item-label">Technical</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-140004-580036/mens-casual?cm_sp=topnav_m_fleece_casual">
                         <div class="item">
                            <div class="item-label">Casual</div>
                         </div>
                      </a>
                   </li>
                </ul>
             </div>
             <div class="group">
                <a href="/c/20001-20030/mens-footwear?cm_sp=topnav_m_footwear">
                   <h2 class="title">Footwear</h2>
                </a>
                <ul>
                <li>
                     <a href="/view/men/shoes/" title="Men's Shoes">
                         <div class="item">
                            <div class="item-label">Shoes</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20030-20031/mens-boots?cm_sp=topnav_m_footwear_boots">
                         <div class="item">
                            <div class="item-label">Boots</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20030-20034/mens-hiking?cm_sp=topnav_m_footwear_hiking">
                         <div class="item">
                            <div class="item-label">Hiking</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20030-580049/mens-casual?cm_sp=topnav_m_footwear_casual">
                         <div class="item">
                            <div class="item-label">Casual</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20030-20037/mens-sandals?cm_sp=topnav_m_footwear_sandals">
                         <div class="item">
                            <div class="item-label">Sandals</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20030-20038/mens-slippers?cm_sp=topnav_m_footwear_slippers">
                         <div class="item">
                            <div class="item-label">Slippers</div>
                         </div>
                      </a>
                   </li>
                </ul>
             </div>
             <div class="group">
                <a href="/view/men/accessories/" title="Men's Accessories">
                   <h2 class="title">Accessories</h2>
                </a>
                <ul>
                   <li>
                      <a href="/c/20001-20002-20003/mens-belts?cm_sp=topnav_m_accessories_belts">
                         <div class="item">
                            <div class="item-label">Belts</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20002-20005/mens-gloves?cm_sp=topnav_m_accessories_gloves">
                         <div class="item">
                            <div class="item-label">Gloves</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20002-20004/mens-hats?cm_sp=topnav_m_accessories_hats">
                         <div class="item">
                            <div class="item-label">Hats</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20002-20006/mens-scarves?cm_sp=topnav_m_accessories_scarves">
                         <div class="item">
                            <div class="item-label">Scarves</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20002-20008/mens-sunglasses?cm_sp=topnav_m_accessories_sunglasses">
                         <div class="item">
                            <div class="item-label">Sunglasses</div>
                         </div>
                      </a>
                   </li>
                   <li>
                      <a href="/c/20001-20002-20007/mens-socks?cm_sp=topnav_m_accessories_socks">
                         <div class="item">
                            <div class="item-label">Socks</div>
                         </div>
                      </a>
                   </li>
                </ul>
             </div>
          </div>
       </div>`
